/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from "react";
import ItemSelector from "../item-selector/item-selector";

export const ItemSelectorWithCreate = props => {
    const { items: options, text, onSelect: defaultOnSelect } = props;
    const [items, setItems] = useState([]);

    useEffect(() => {
        const _items = Array.isArray(options) && text !== null ? options : [];
        if(options !== null){
            if(text && text !== '' && !_items.map(item => item.name?.toUpperCase()).includes(text?.toUpperCase()) && !_items.map(item => item._id).includes(null)){
                _items.push({ _id: null, name: 'Create "' + text + '"', text });
            }
        }
        setItems(_items);
    }, [text, options]);

    const onSelect = p => {
        p.name = p._id === null ? p.text : p.name;
        p._id = p._id === null ? p.text : p._id;
        return defaultOnSelect(p);
    };

    return (
        <ItemSelector 
            {...props}
            items={items}
            onSelect={onSelect}
        />
    );
};


